<template>
    <div class="content-widget">
        <div
            class="content-widget"
            ref="threeDHolder"
            v-show="isWidgetVisible"
            @click="antiScroll()"
        />
        <ScrollButton
            v-if="isWheelLocked"
            :toggleModeWheel="toggleModeWheel"
            :options="data"
        />
        <ThreeDController
            v-if="data.gui && data.gui.type === '3d-plan'"
            :data="data"
            :widget="widget"
            :widgetType="'3d-plan'"
            :targetElement="targetElement"
            :class="{ 'mb-14': hasFunnel }"
        />
        <FunnelFooter v-if="hasFunnel"/>
    </div>
</template>


<script>
    import { EventBus } from '@/event-bus';
    import Http from '@/api/data';
    import { mapActions, mapGetters } from 'vuex';

    import ThreeDController from "@/components/threeDController/ThreeDController";
    import ScrollButton from "@/components/ScrollButton";
    import FunnelFooter from "@/components/funnel/FunnelFooter";

    export default {
        name: 'ThreeDWidget',
        components: {
            ThreeDController,
            ScrollButton,
            FunnelFooter
        },
        props: [
            'data',
            'link',
            'active',
            'standalone'
        ],
        data: () => ({
            isIE: false,
            targetElement: null,
            widget: null,
            toggleModeWheel: false,
            isWidgetVisible: true 
        }),
        computed: {
            ...mapGetters([
                'isOfflineMode',
                'isReviewUse',
                'language',
                'protocol',
                'isIframe'
            ]),
            ...mapGetters('widget', [
                'funnel'
            ]),
            isWheelLocked() {
                return window.self !== window.top;
            },
            apiUrl() {
                return this.protocol + (this.isReviewUse ? process.env.API_LIST.REVIEW : process.env.API_LIST.FO);
            },
            hasFunnel() {
                return this.funnel && !this.isFunnel;
            },
            isFunnel() {
                return this.isIframe && document.referrer === process.env.FUNNEL_URL;
            }
        },
        mounted() {
            this.isIE = window.navigator.msPointerEnabled;
            this.targetElement = this.$refs.threeDHolder;
            this.render();

            EventBus.$on('3d_SetActive', (item, subitem) => {
                if (subitem && !subitem.active) {
                    let currentItem = this.$props.data.items.filter(el => el.id === item.id);
                    if (currentItem)
                        currentItem[0].submenu.filter(el => el.active).forEach(el => { el.active = false });
                    this.$set(subitem, 'active', true);
                } else if (!item.active) {
                    this.$props.data.items.filter(el => el.active).forEach(el => { el.active = false });
                    this.$set(item, 'active', true);
                }
                let urlLink = subitem ? subitem.link : item.link;
                this.updateData(urlLink);
            });
        },
        methods: {
            ...mapActions([
                'setIsLoading'
            ]),
            callbacks() {
                let vm = this;
                return {
                    callbacks: {
                        widgetReadyCallback(widget) {
                            EventBus.$emit('widgetReady', widget);
                            vm.setIsLoading(false);
                        }
                    }
                };
            },
            render() {
                let urlLink = this.$props.link ? this.$props.link : this.apiUrl + '/request-data/3d-plan' + window.location.search;
                if (this.language && !urlLink.includes('&language'))
                    urlLink += '&language=' + this.language;
                if (this.isOfflineMode && !urlLink.includes('&offline'))
                    urlLink += '&offline';

                Http.getData(urlLink).then(payload => {
                    if (payload) {
                        payload.gui.type = '3d-plan';
                        payload = Object.assign(payload, this.callbacks());
                        payload.title = this.data.title;

                        const currentWidget = payload.items.filter(el => el.active)[0];
                        let submenu = currentWidget.submenu ? currentWidget.submenu.filter(menu => menu.active)[0] : null;
                        let widgetSubid = submenu && submenu.alternateModel ? `${submenu.alternateModel}-${currentWidget.subid}` : currentWidget.subid;
                        payload.widgetType = `3d-plan-${widgetSubid}`;

                        if (payload.language)
                            this.$i18n.locale = payload.language;

                        if (this.standalone)
                            payload.type = 'plot';
                        else
                            payload = Object.assign(payload, {
                                items: this.data.items,
                                widgetTitle: this.data.widgetTitle
                            });

                        payload.isInternal = this.isInternal;
                        this.widget = new Habiteo.DigitalModelWidget(this.$refs.threeDHolder, payload);
                        if (this.standalone) {
                            EventBus.$emit('setSidebarData', payload);
                            EventBus.$emit('updateLoadedWidgets', {
                                id: '3d-plan',
                                link: urlLink,
                                active: true,
                                widgetType: '3d-plan'
                            });
                        } else
                            EventBus.$emit('updateSidebar', payload, false);
                        EventBus.$emit('trackWidget', payload.tracking);
                    }
                }).catch(error => {
                    EventBus.$emit('setErrorState', true, error);
                });
            },
            updateData(link) {
                this.isWidgetVisible = false;
                if (this.isOfflineMode && !link.includes('&offline'))
                    link += '&offline';
                Http.getData(link).then(payload => {
                    this.isWidgetVisible = true;
                    // hard fix to show the widget good size
                    window.dispatchEvent(new Event('resize'));

                    if (payload) {
                        if (!payload.gui)
                            payload.gui = {};
                        payload.gui.type = '3d-plan';

                        const currentWidget = payload.items.find(el => el.active);
                        let submenu = currentWidget.submenu ? currentWidget.submenu.find(menu => menu.link == link) : null;
                        let widgetSubid = submenu && submenu.alternateModel ? `${submenu.alternateModel}-${currentWidget.subid}` : currentWidget.subid;
                        payload.widgetType = `3d-plan-${widgetSubid}`;

                        payload.title = this.data.title;
                        payload = Object.assign(payload, {
                            items: this.data.items,
                            widgetTitle: this.data.widgetTitle
                        });
                        this.widget.loadData(payload);
                        EventBus.$emit('updateLoadedWidgets', {
                            id: '3d-plan',
                            link: link,
                            active: true,
                            widgetType: '3d-plan'
                        });
                        EventBus.$emit('updateSidebar', payload, false);
                        EventBus.$emit('trackWidget', payload.tracking);
                    }
                }).catch(error => {
                    EventBus.$emit('setErrorState', true, error);
                });
            },
            triggerResize() {
                if (this.isIE) {
                    let evt = window.document.createEvent('UIEvents');
                    evt.initUIEvent('resize', true, false, window, 0);
                    window.dispatchEvent(evt);
                }
                else
                    window.dispatchEvent(new Event('resize'));
            },
            antiScroll(){
                this.widget.unlockMouseWheel();
                this.toggleModeWheel = !this.toggleModeWheel;
            }
        },
        watch: {
            active(val) {
                if (val) {
                    this.updateData(this.link);
                    this.triggerResize();
                }
            },
            link(val, oldVal) {
                if (this.active && oldVal)
                    this.updateData(val);
            }
        }
    };
</script>

<style lang="scss">
    @import "@/assets/scss/_common.scss";
    @import "@/assets/scss/main.scss";
    @import "@/assets/scss/components/_sidebar.scss";
    .content-widget{
        height: 100vh;
        height: calc(var(--vh, 1vh) * 100);
        position: relative;
    }
</style>


// WEBPACK FOOTER //
// src/views/ThreeDWidget.vue